import { SettingsConfiguration } from "@is/types";

export const CLIENT_WEBPAGE_URL = "https://iso-staff-portal.azurewebsites.net/";
export const PRIVACY_POLICY_URL = "https://bestseller.com/privacy-policy";

export enum PasscodeOptions {
  CUSTOM = "Custom",
  STOREID = "StoreID",
  DISABLED = "Disabled",
}

export const defaultConfigurationState = {
  attributes: [],
  staffDashboard: {
    portalUrl: "",
    passcodeOption: PasscodeOptions.DISABLED,
    customPasscode: "",
  },
  backgroundMedia: {
    vertical: null,
    horizontal: null,
    discoverYourOutfits: false,
  },
  appearance: {
    baseFontUrl: "",
    displayFontUrl: "",
    colors: {
      primary: "",
      secondary: "",
      tertiary: "",
      sale: "",
    },
    baseFontStrongUrl: "",
  },
  basketAiSuggestions: {
    enableHowAboutThese: true,
  },
  checkoutAgreements: [],
  checkoutGeneral: {
    enableCountrySelection: false,
  },
  customAttributes: [],
  productDetailsView: {
    enableHowToWearIt: true,
    enableYouMayAlsoLike: true,
  },
  localizedMedia: [],
  loyaltySignupForm: undefined,
  timeouts: {
    idle: { minutes: "5", seconds: "0" },
    loadingBar: { minutes: "1", seconds: "0" },
  },
} as SettingsConfiguration;

export const configurationMockedState = {
  data: defaultConfigurationState,
  appearance: defaultConfigurationState?.appearance,
  attributes: defaultConfigurationState?.attributes ?? [],
  backgroundMedia: defaultConfigurationState?.backgroundMedia,
  basketAiSuggestions: defaultConfigurationState?.basketAiSuggestions,
  checkoutAgreements: defaultConfigurationState?.checkoutAgreements ?? [],
  checkoutGeneral: defaultConfigurationState?.checkoutGeneral,
  customAttributes: defaultConfigurationState?.customAttributes ?? [],
  localizedMedia: defaultConfigurationState?.localizedMedia ?? [],
  productDetailsView: defaultConfigurationState?.productDetailsView,
  staffDashboard: defaultConfigurationState?.staffDashboard,
  loyaltySignupForm: defaultConfigurationState?.loyaltySignupForm,
  timeouts: defaultConfigurationState?.timeouts,
};
